import { FocusRing } from '@change/ds-core-ui';
import { ArrowLeftIcon, ArrowRightIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

import { TopImpactStorySummary } from '../../../shared/components/TopImpactStorySummary';

import { useFooter } from './hooks/useFooter';

type Props = {
	dataTestId: string;
};

export const Footer: React.FC<Props> = ({ dataTestId }) => {
	const {
		data: { currentStorySummary, isSummaryFading },
		actions: { onLeftClick, onRightClick },
	} = useFooter();

	const { translate } = useI18n();

	return (
		<div className="flex h-28 items-center justify-center gap-4">
			<FocusRing focusRingClass="outline-2">
				<button
					type="button"
					onClick={onLeftClick}
					aria-label={translate('corgi.homepage.top_impact_stories.mobile.left_arrow_label')}
					data-testid="left-arrow"
					data-qa="left-arrow"
				>
					<ArrowLeftIcon className="text-content-accent" size="large" />
				</button>
			</FocusRing>

			<TopImpactStorySummary
				summary={currentStorySummary}
				dataTestId={dataTestId}
				isMobile
				isFading={isSummaryFading}
			/>

			<FocusRing focusRingClass="outline-2">
				<button
					type="button"
					onClick={onRightClick}
					aria-label={translate('corgi.homepage.top_impact_stories.mobile.right_arrow_label')}
					data-testid="right-arrow"
					data-qa="right-arrow"
				>
					<ArrowRightIcon className="text-content-accent" size="large" />
				</button>
			</FocusRing>
		</div>
	);
};
